import { SignInPage } from '@backstage/core-components';
import {
  configApiRef,
  microsoftAuthApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint, type SignInPageProps } from '@backstage/plugin-app-react';

const microsoftProvider = {
  id: 'microsoft-auth-provider',
  title: 'Microsoft',
  message: 'Sign in using Microsoft Azure AD',
  apiRef: microsoftAuthApiRef,
};

function MicrosoftSignInPage(props: SignInPageProps) {
  const allowGuest =
    useApi(configApiRef).getOptionalBoolean('app.signIn.guest') ?? false;

  if (allowGuest) {
    return <SignInPage {...props} providers={['guest', microsoftProvider]} />;
  }

  return <SignInPage {...props} auto provider={microsoftProvider} />;
}

const signInPageModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    SignInPageBlueprint.make({
      params: {
        loader: async () => MicrosoftSignInPage,
      },
    }),
  ],
});

export default signInPageModule;
